@if (loading) {
<div class="loading-container">
  <mat-spinner diameter="36"></mat-spinner>
  <p>{{ loadingText }}</p>
</div>
} @else {
<div class="summary">
  Total: <strong>{{ filteredAllocations.length }}</strong> &nbsp;·&nbsp;
  Locked: <strong>{{ countByStatus('Locked') }}</strong> &nbsp;·&nbsp;
  Bought: <strong>{{ countByStatus('Bought') }}</strong> &nbsp;·&nbsp;
  Expired: <strong>{{ countByStatus('Expired') }}</strong>
</div>

<div class="players-list">
  @for (group of allocationGroups; track group.key) {
  <mat-accordion class="player-accordion">
    <mat-expansion-panel class="player-card" [class]="group.items[0].status.toLowerCase()">
      <mat-expansion-panel-header>
        <div class="player-header-expandable">
          @if (group.items[0].player_image_path) {
          <div class="player-thumb-wrapper" #thumbOrigin
            (click)="showImagePreview(thumbOrigin, group.items[0].player_image_path); $event.stopPropagation()">
            <img class="player-thumb" [src]="group.items[0].player_image_path" [alt]="group.items[0].player_name" />
          </div>
          }
          <div class="player-info">
            <div class="player-title">
              <span class="player-name">
                {{ group.items[0].player_name }}
                @if (group.items[0].player_nickname && group.items[0].player_nickname !== group.items[0].player_name)
                {
                ({{ group.items[0].player_nickname }})
                }
              </span>
            </div>
            <div class="player-meta">
              <span class="count-badge">×{{ group.count }}</span>
              <span [class]="'status-badge ' + getAllocationStatusClass(group.items[0].status)">{{ group.items[0].status
                }}</span>
            </div>
          </div>

          <div class="price-info">
            <div class="price-row">
              <span class="price-label">Start Bid:</span>
              <span class="price-value">{{ group.items[0].bid_price | number }}</span>
            </div>
            <div class="price-row">
              <span class="price-label">Buy Now:</span>
              <span class="price-value">{{ group.items[0].buy_now_price | number }}</span>
            </div>
          </div>
        </div>
      </mat-expansion-panel-header>

      <div class="expansion-content">
        <div class="table-container">
          <table mat-table [dataSource]="group.items" class="mat-elevation-z4">
            <ng-container matColumnDef="player">
              <th mat-header-cell *matHeaderCellDef>Player</th>
              <td mat-cell *matCellDef="let a">
                <div class="player-cell">
                  <span class="player-name">{{ a.player_name }}</span>
                  @if (a.player_nickname && a.player_nickname !== a.player_name) {
                  <span class="player-nick">({{ a.player_nickname }})</span>
                  }
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="buy_now_price">
              <th mat-header-cell *matHeaderCellDef>Buy Now</th>
              <td mat-cell *matCellDef="let a">{{ formatCoins(a.buy_now_price) }}</td>
            </ng-container>

            <ng-container matColumnDef="quality">
              <th mat-header-cell *matHeaderCellDef>Quality</th>
              <td mat-cell *matCellDef="let a">{{ a.quality }}</td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let a">
                <span [class]="'status-badge ' + getAllocationStatusClass(a.status)">{{ a.status }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="lock_expires_at">
              <th mat-header-cell *matHeaderCellDef>Lock expires</th>
              <td mat-cell *matCellDef="let a">
                @if (a.status === 'Locked') {
                {{ formatTimeRemaining(a.lock_expires_at) }}
                } @else {
                <span class="empty-value">—</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="expire_time">
              <th mat-header-cell *matHeaderCellDef>Listing expires</th>
              <td mat-cell *matCellDef="let a">{{ formatTimeRemaining(a.expire_time) }}</td>
            </ng-container>

            @if (canShowHistory) {
            <ng-container matColumnDef="history">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let a">
                <button mat-icon-button matTooltip="Show card history" (click)="showCardHistory(a.card_id)">
                  <mat-icon>history</mat-icon>
                </button>
              </td>
            </ng-container>
            }

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>

        <div class="allocation-cards">
          @for (a of group.items; track a.card_id) {
          <div class="allocation-card">
            <div class="allocation-card-top">
              <div class="player-cell">
                <span class="player-name">{{ a.player_name }}</span>
                @if (a.player_nickname && a.player_nickname !== a.player_name) {
                <span class="player-nick">({{ a.player_nickname }})</span>
                }
              </div>
              <span [class]="'status-badge ' + getAllocationStatusClass(a.status)">{{ a.status }}</span>
            </div>
            <div class="allocation-card-meta">
              <div>
                <span class="meta-label">Buy Now</span>
                {{ formatCoins(a.buy_now_price) }}
              </div>
              <div>
                <span class="meta-label">Quality</span>
                {{ a.quality }}
              </div>
              <div>
                <span class="meta-label">Lock expires</span>
                @if (a.status === 'Locked') {
                {{ formatTimeRemaining(a.lock_expires_at) }}
                } @else {
                <span class="empty-value">—</span>
                }
              </div>
              <div>
                <span class="meta-label">Listing expires</span>
                {{ formatTimeRemaining(a.expire_time) }}
              </div>
            </div>
            @if (canShowHistory) {
            <button mat-stroked-button class="history-btn" (click)="showCardHistory(a.card_id)">
              <mat-icon>history</mat-icon>
              History
            </button>
            }
          </div>
          }
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  }

  @if (allocations.length === 0) {
  <div class="empty-state">{{ emptyMessage }}</div>
  }
</div>
}

<ng-template #imagePreviewTpl>
  <div (click)="hideImagePreview()">
    <img class="player-thumb-overlay" [src]="previewImageUrl" alt="Player preview" />
  </div>
</ng-template>